<template>
  <!-- 客户详细信息 -->
  <div class="pagesContent"  @scroll="handleScroll" ref="content">
    <!-- 内容部分 -->
    <div class="main_box">
      <el-card class="card-box section">
        <div class="single-title">
          公司信息
        </div>
        <div class="single-model-company">
          <!-- 表单 -->
          <el-form :model="modifyCompanyInfo" label-width="100px" class="demo-ruleForm">
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="公司名称" prop="CompanyName">
                  <el-input v-model="CompanyInfo.CompanyName" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="公司编号" prop="CompanyId">
                  <el-input v-model="CompanyInfo.CompanyId" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="负责人">
                    <el-input v-model="CompanyInfo.PersonIncharge" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="公司官网">
                    <el-input v-model="CompanyInfo.CompanyWebsite" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="产品注册证">
                  <el-input v-model="CompanyInfo.ProductionLicense" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="邮箱">
                    <el-input v-model="CompanyInfo.Email" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="移动电话">
                    <el-input v-model="CompanyInfo.MobilePhone" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="公司地址">
                     <el-cascader
                          size="small"
                          :options="options"
                          v-model="areaOptions"
                          @change="areaChange"
                          disabled>
                      </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="固定电话">
                    <el-input v-model="CompanyInfo.Contactinformation" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="详细地址">
                    <el-input v-model="CompanyInfo.DetailedAddress" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="软件注册时间">
                  <el-date-picker type="date" placeholder="选择日期"
                          v-model="CompanyInfo.RegistrationTime"
                          style="width: 100%;"
                          size="small" disabled>
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="到期时间">
                  <el-date-picker type="date" placeholder="选择日期"
                          v-model="CompanyInfo.Deadline"
                          style="width: 100%;"
                          size="small" disabled>
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="对接负责人">
                  <el-input v-model="CompanyInfo.TBPersonIncharge" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="对接联系电话">
                  <el-input v-model="CompanyInfo.TBContactinformation" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="服务器电脑名">
                    <el-input v-model="CompanyInfo.ServerHostName" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="MAC地址">
                    <el-input v-model="CompanyInfo.MAC" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="CPU编号">
                    <el-input v-model="CompanyInfo.CPUId" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="软件认证码">
                    <el-input v-model="CompanyInfo.EncryptedString" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="用户名">
                  <el-input v-model="CompanyInfo.UserName" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="密码">
                  <el-input v-model="CompanyInfo.Password" size="small" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
                <el-col :span="19" :offset="1">
                  <el-form-item label="公司简介">
                      <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="CompanyInfo.CompanyProfile" size="small" disabled></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
                  <!-- <el-row>
                    <el-col :span="9" :offset="1">
                      <el-form-item label="合作状态">
                        <el-select v-model="CompanyInfo.cooperationstatus" placeholder="请选择合作状态" size="small" disabled>
                          0 不合作  1 合作
                          <el-option v-for="item in cooperationstatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9" :offset="1">
                      <el-col :span="9" :offset="1">
                        <el-form-item label="APP开通">
                            <el-checkbox-group v-model="CompanyInfo.Appopening" size="small" disabled>
                              <el-checkbox-button label="0" name="type">AI匠-管</el-checkbox-button>
                              <el-checkbox-button label="1" name="type">AI匠-技</el-checkbox-button>
                              <el-checkbox-button label="2" name="type">AI匠-业</el-checkbox-button>
                              <el-checkbox-button label="3" name="type">AI匠-医</el-checkbox-button>
                              <el-checkbox-button label="4" name="type">AI匠-TV</el-checkbox-button>
                            </el-checkbox-group>
                        </el-form-item>
                      </el-col>
                    </el-col>
                  </el-row> -->
            <el-row>
              <el-col :span="9" :offset="1">
                <el-form-item label="维护人">
                  <el-select v-model="CompanyInfo.TBEmployeeJobNumber" placeholder="请选择维护人" size="small" @change="changeEmployeeJobNum">
                     <el-option v-for="item in staffOptions" :key="item.jobId" :label="item.name" :value="item.jobId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="9" :offset="2">
                <el-form-item label="系统类型">
                    <el-select v-model="CompanyInfo.SystemTypeId" placeholder="请选择系统类型" size="small" @change="changeSystemTypeId">
                      <el-option v-for="item in systemtypeIdOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
      <el-card class="card-box section">
        <div class="single-title">
          穿透信息
        </div>
        <div class="single-model-other" v-if="FrpData.length > 0">
          <h4 style="margin-bottom: 10px;" v-if="FrpTcpData.length > 0">TCP 类型</h4>
          <el-table :data="FrpTcpData" v-if="FrpTcpData.length > 0" stripe border style="width: 100%" height="260">
            <el-table-column prop="CompanyId" label="公司编号" width="220" align="center"></el-table-column>
            <el-table-column prop="frpsInfo.ServerAddress" label="穿透地址" width="190" align="center"></el-table-column>
            <el-table-column prop="SectionName" label="节点名称" width="190" align="center"></el-table-column>
            <el-table-column prop="type" label="穿透类型" width="100" align="center"></el-table-column>
            <el-table-column prop="local_ip" label="客户端IP" width="180" align="center"></el-table-column>
            <el-table-column prop="local_port" label="客户端端口" align="center"></el-table-column>
            <el-table-column prop="remote_port" label="远程端口" align="center"></el-table-column>
          </el-table>
          <h4 style="margin-top: 20px; margin-bottom: 10px;" v-if="FrpHttpData.length > 0">HTTP 类型</h4>
          <el-table :data="FrpHttpData" v-if="FrpHttpData.length > 0" stripe border style="width: 100%" height="260">
            <el-table-column prop="CompanyId" label="公司编号" width="220" align="center"></el-table-column>
            <el-table-column prop="frpsInfo.ServerAddress" label="穿透地址" width="180" align="center"></el-table-column>
            <el-table-column prop="SectionName" label="节点名称" width="180" align="center"></el-table-column>
            <el-table-column prop="type" label="穿透类型" width="100" align="center"></el-table-column>
            <el-table-column prop="local_ip" label="客户端IP" width="180" align="center"></el-table-column>
            <el-table-column prop="local_port" label="客户端端口" align="center"></el-table-column>
            <el-table-column prop="use_encryption" label="消息加密" align="center">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.use_encryption" disabled>加密</el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="use_gzip" label="消息压缩" align="center">
              <template slot-scope="scope">
                <el-checkbox v-model="scope.row.use_gzip" disabled>压缩</el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="custom_domains" label="自定义域名" width="200" align="center"></el-table-column>
          </el-table>
        </div>
        <div v-else class="noFrp">暂无穿透信息</div>
      </el-card>
      <el-card class="card-box section">
        <div class="single-title">
          版本信息
        </div>
        <div class="single-model-other">
          <el-table :data="VersionData" stripe border style="width: 100%" height="400">
            <el-table-column prop="CompanyId" label="公司编号" align="center"></el-table-column>
            <el-table-column prop="SoftwareId" label="软件编号" width="160" align="center"></el-table-column>
            <el-table-column prop="Software.Name" label="软件名称" align="center"></el-table-column>
            <el-table-column prop="Version" label="版本号" width="180" align="center"></el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" align="center">
                <template slot-scope="scope">{{scope.row.CreateTime| dateYMDFormat}}</template>
            </el-table-column>
            <el-table-column prop="LastUpdateTime" label="最后修改时间" align="center">
              <template slot-scope="scope">{{scope.row.LastUpdateTime| dateYMDFormat}}</template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card class="card-box section">
        <div class="single-title">
          版本升级记录
        </div>
        <div class="single-model-other">
          <el-table :data="VersionRecord" stripe border style="width: 100%" height="400">
            <el-table-column prop="CompanyId" label="工厂编号" width="220" align="center"></el-table-column>
            <el-table-column prop="SoftwareId" label="软件编号" align="center"></el-table-column>
            <el-table-column prop="Software.Name" label="软件名称" width="140" align="center"></el-table-column>
            <el-table-column prop="Version" label="版本号" width="180" align="center"></el-table-column>
            <el-table-column prop="ToVersion" label="请求版本号" width="180" align="center"></el-table-column>
            <el-table-column prop="CreateTime" label="请求时间" align="center">
              <template slot-scope="scope">{{scope.row.CreateTime| dateYMDFormat}}</template>
            </el-table-column>
            <el-table-column prop="Status" label="请求状态" align="center">
              <template slot-scope="scope">   <!-- （ 0未知  1准备升级  2升级成功 3升级失败 4升级异常 ） -->
                <span v-if="scope.row.Status == 1">准备升级</span>
                <span v-else-if="scope.row.Status == 2">升级成功</span>
                <span v-else-if="scope.row.Status == 3">升级失败</span>
                <span v-else-if="scope.row.Status == 4">升级异常</span>
                <span v-else>未知</span>
              </template>
            </el-table-column>
            <el-table-column prop="Text" label="请求文本" width="200" align="center"></el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-card class="card-box section">
        <div class="single-title">
          续费记录
        </div>
        <div class="single-model-other">
          <el-table :data="PayRecord" stripe border style="width: 100%" height="400">
            <el-table-column type="index" label="编号" align="center" width="80"></el-table-column>
            <el-table-column prop="Company.CompanyName" label="公司名称" align="center" width="360"></el-table-column>
            <el-table-column prop="AuthDate" label="开通时间" align="center" sortable>
                <template slot-scope="scope">{{scope.row.AuthDate | dateYMDFormat}}</template>
            </el-table-column>
            <el-table-column prop="Deadline" label="到期时间" align="center" sortable>
                <template slot-scope="scope">{{scope.row.Deadline | dateYMDFormat}}</template>
            </el-table-column>
            <el-table-column prop="AuthPerson" label="开通人" align="center" width="160"></el-table-column>
            <el-table-column prop="Remark" label="备注" align="center" width="450"></el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
    <!-- 目录部分 -->
    <div class="catalogue_box">
      <div class="catalogue_title">目录</div>
      <el-tabs @tab-click="tabClick" v-model="activeName" :tab-position="tabPosition" style="height: 200px;">
        <el-tab-pane :name="'tab'+ index"
          :class="index == 0 ?'current':''"
          v-for="(item, index) in cardList"
          :key="index"
          :label="item.name"></el-tab-pane>
      </el-tabs>
    </div>
  </div>

</template>

<script>
  // 地区
  import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data'
  // provinceAndCityData是省市二级联动数据（不带“全部”选项）
  // regionData是省市区三级联动数据（不带“全部”选项）
  // provinceAndCityDataPlus是省市区二级联动数据（带“全部”选项）
  // regionDataPlus是省市区三级联动数据（带“全部”选项）
  // "全部"选项绑定的value是空字符串""
  // CodeToText是个大对象，属性是区域码，属性值是汉字 用法例如：CodeToText['110000']输出北京市
  // TextToCode是个大对象，属性是汉字，属性值是区域码 用法例如：TextToCode['北京市'].code输出110000,TextToCode['北京市']['市辖区'].code输出110100,TextToCode['北京市']['市辖区']['朝阳区'].code输出110105

  export default{
    data (){
      return{
          //页面滚动
          activeName:'tab0',
          tabPosition:'right',
          cardList:[
            {
              name: "公司信息",
              }, {
              name: "穿透信息",
              }, {
              name: "版本信息",
              }, {
              name: "版本升级记录",
              }, {
              name: "续费记录",
              }
          ],
          //获取地区
          // options: regionData,
          options: [],
          //工厂id
          CompanyId: this.$route.query.CompanyId,
          //公司信息
          CompanyInfo:[],
          areaOptions:[],  //省市区代码 ["410000","410100","410101"]
          //修改公司信息
          modifyCompanyInfo:{},
          //穿透信息
          FrpData:[],
          FrpTcpData: [],  //tcp 数据列表
          FrpHttpData: [],  //http 数据列表
          //工厂版本信息表
          VersionData:[],
          //公司版本升级记录
          VersionRecord:[],
          //续费记录
          PayRecord:[],
          //系统版本类型（单机版、网络版...）
          systemtypeIdOptions:[],
          //在职员工
          staffOptions:[],
          //合作状态
          // cooperationstatusOptions: [
          //   {value: '0',label:'不合作'},
          //   {value: '1',label:'合作'}
          // ],
      }
    },
    mounted(){
      // console.log(this.CompanyId)
      //获取地区
      this.getAddress()
      // console.log(this.options)
      //系统版本类型
      this.getSystemtypeAll()
      //公司信息
      this.getCompanyInfo()
      //穿透信息
      this.getCompanyFrp()
      //版本信息
      this.getCompanyVersion()
      //版本升级记录
      this.getAllVersionRecord()
      //续费记录
      this.getAllPayLog()
      //所有在职员工
      this.getStaffList()
    },
    methods:{
      /* 获取地区 */
      getAddress(){
        this.$http.getAllAddress().then(res=>{
          if(res.status == 200){
            this.options = res.data
            console.log(this.options)
          }else{
            this.$message.error({
              message: '查询地区失败！'
            })
          }
        })
      },
      //滚动事件
      handleScroll (el) {
        this.scrollTop = this.$refs.content.scrollTop
        // console.log(this.scrollTop)
        this.loadScroll() //对比确定 高亮项
      },
      //tab 点击事件 ( tab相当于item )
      tabClick(tab,event){
        // console.log(tab.index)
        this.jump(tab.index)
      },
      jump(index) {
        let jump = document.getElementsByClassName('section');
        // 获取需要滚动的距离
        let total = jump[index].offsetTop;  //根据点击的 index, 获取其 距顶部的距离
        // console.log(total)
        //滚动条
        document.querySelector('.pagesContent').scrollTo(0, total)
      },
      // 用循环的方式将每个标题离顶部的距离与滚动条当前位置对比来确定哪个标题需要变为高亮
      loadScroll() {
        var _this = this;
        var sections = document.getElementsByClassName('section');
        for (var i = sections.length - 1; i >= 0; i--) {
          // console.log(i)
          // console.log(_this.scrollTop)
          // console.log(sections[i].offsetTop)
          if (_this.scrollTop >= sections[i].offsetTop - 100) {
          //上面规定了每个el-tab-pane标签的name属性值为tab+该标签的index值
            _this.activeName = 'tab'+ i
            break;
          }
        }
      },
      //修改公司维护人
      changeEmployeeJobNum(value){
        // console.log(value)
        var employeeJobNumber = value
        let employee = '?jobNumber=' + this.UserData.JobNumber
                     + '&&companyId=' + this.CompanyInfo.CompanyId
                     + '&&employeeJobNumber=' + employeeJobNumber
        this.$http.SetCompanyTBEmployee(employee).then(res=>{
           // console.log(res)
           if(res.status == 200){
             this.$message.success({
               message: '修改公司维护人成功！'
             })
           }else{
             this.$message.error({
               message: '修改公司维护人失败！'
             })
           }
        })
      },
      //修改公司系统类型
      changeSystemTypeId(value){
        // console.log(value)
        var systemTypeId = value
        let systemtype = '?jobNumber=' + this.UserData.JobNumber
                     + '&&companyId=' + this.CompanyInfo.CompanyId
                     + '&&systemTypeId=' + systemTypeId
        this.$http.SetCompanySystemType(systemtype).then(res=>{
           console.log(res)
           if(res.status == 200){
             this.$message.success({
               message: '修改公司系统类型成功！'
             })
           }else{
             this.$message.error({
               message: '修改公司系统类型失败！'
             })
           }
        })
      },
      //查询员工列表 (在职 )
      getStaffList(SearchFlag){
        let status = '?flag=1'
        this.$http.getStaffList(status).then(res=>{
          if(res.status == 200){
            var staffList = res.data
            // console.log(staffList)  // JobNumber Name
            //遍历数据 构造版本类型新数组
            for(var i=0; i<staffList.length; i++){
                // console.log(i)
                var staff = {
                  jobId: staffList[i].JobNumber,
                  name: staffList[i].Name
                }
                this.staffOptions.push(staff)
            }
            // console.log("所有员工")
            // console.log(this.staffOptions)
          }else{
              this.$message.error({
                message: '查询所有在职员工失败！'
              })
          }
        })
      },
      //查询所有系统类型
      getSystemtypeAll(){
        this.$http.getSystemAll().then(res=>{
          if(res.status == 200){
              var SystemtypeData = res.data
              // console.log(SystemtypeData)
              //遍历数据 构造版本类型新数组
              for(var i=0; i<SystemtypeData.length; i++){
                  // console.log(i)
                  var system = {
                    id: SystemtypeData[i].Id,
                    name: SystemtypeData[i].Name
                  }
                  this.systemtypeIdOptions.push(system)
              }
              // console.log("所有系统类型")
              // console.log(this.systemtypeIdOptions)
          }else{
              this.$message.error({
                message: '查询版本类型信息失败！'
              })
          }
        })
      },
      //公司信息
      getCompanyInfo(){
        let companyId = '?companyId=' + this.CompanyId
        this.$http.getCompanyInfo(companyId).then(res=>{
          // console.log("公司信息")
          // console.log(res.data)
          if(res.status == 200){
             this.CompanyInfo = res.data
             //地区选项 省市区
             this.areaOptions = [this.CompanyInfo.AddressProvinceCode, this.CompanyInfo.AddressCityCode, this.CompanyInfo.AddressAreaCode]
          }
        })
      },
      //穿透信息
      getCompanyFrp(){
        let companyId = '?companyId=' + this.CompanyId
        this.$http.getAllCompanyFrp(companyId).then(res=>{
          // console.log("穿透信息")
          // console.log(res.data)
          if(res.status == 200){
            this.FrpData = res.data
            //遍历 分类 tcp http
            var FrpTcpData = []
            var FrpHttpData = []
            this.FrpData.forEach(function(item,index){
              if(item.type == "tcp"){
                FrpTcpData.push(item)
              }else if(item.type == "http"){
                FrpHttpData.push(item)
              }
            })
            this.FrpTcpData = FrpTcpData
            this.FrpHttpData = FrpHttpData
          }
        })
      },
      //版本信息
      getCompanyVersion(){
        let companyId = '?companyId=' + this.CompanyId
        this.$http.getAllCompanyVersion(companyId).then(res=>{
          // console.log("版本信息")
          // console.log(res.data)
          if(res.status == 200){
             this.VersionData = res.data
          }
        })
      },
      //版本升级记录
      getAllVersionRecord(){
        let companyId = '?companyId=' + this.CompanyId
        this.$http.getAllCompanyVersionLog(companyId).then(res=>{
          // console.log("版本升级记录")
          // console.log(res)
          this.VersionRecord = res.data
        })
      },
      //续费记录
      getAllPayLog(){
        let companyId = '?companyId=' + this.CompanyId
        this.$http.getAllGetAllDredgeLog(companyId).then(res=>{
          console.log("续费记录")
          console.log(res.data)
          this.PayRecord = res.data
        })
      },
      //改变地区联动器  地区代码
      areaChange (value) {
        // console.log(value)
        //地区代码 赋值 公司对象
        this.companyForm.areaOptions = value
      }
    }
  }

</script>

<style scoped>

  .pagesContent {
    width: 100%;
    height: 790px;
    overflow-y: scroll;
    display: flex;
    justify-content: flex-start;
    position: relative;
  }
  /* 左右布局 */
  .main_box{
    width: 90%;
  }
  .card-box {
    margin-bottom: 40px;
  }
  .catalogue_box{
    width: 10%;
    height: 780px;
    position: fixed;
    top: 100px;
    right: 70px;
  }
  .catalogue_title{
    margin: 10px 0 20px 70px;
    font-size: 18px;
    font-weight: bold;
  }
  .el-aside {
    background-color: #D3DCE6;
    height: auto;
  }
  .single-title {
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    font-weight: 800;
    border-bottom: #CCCCCC 1px solid;
  }
  .single-model-company {
    padding: 20px 0 0 40px;
    margin-bottom: 40px;
  }
  .single-model-other {
    padding: 20px 20px 0;
  }
  .noFrp {
    color: #666666;
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 14px;
  }

  /* 深度选择器 */
  .el-input.is-disabled /deep/ .el-input__inner {
       color: #606266;
   }
   .el-textarea.is-disabled /deep/ .el-textarea__inner {
       color: #606266;
   }
   /* 地址选择器 */
   .el-cascader /deep/ .el-input.is-disabled .el-input__inner {
     color: #606266;
   }
   /* 下拉选择器 */
  .el-select /deep/ .el-input.is-disabled .el-input__inner {
     color: #606266;
   }
   /* 方形选中框 多选*/
  .el-checkbox-button.is-checked /deep/ .el-checkbox-button__inner {
     color: #FFFFFF;
     background-color: #409EFF;
   }
   /* 勾选框 */
   .el-checkbox /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
     border-color: #409EFF;
     background-color: #409EFF;
   }
   .el-checkbox /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
     border-color: #FFFFFF;
   }

</style>
